import React from 'react'

// components
import {
  CButton,
  CRow,
  CSpinner
} from '@coreui/react-pro'
import AppModal from '../AppModal'
import AppCard from '../AppCard'
import AppCardHeader from '../card/AppCardHeader'
import FormFileUpload from '../form/general-input-form/FormFileUpload'
import AppForm from '../form/form-invoice/AppForm'
import AppFormExpense from '../form/form-expense/AppForm'
import AppFormPayroll from '../form/form-payroll/AppForm'
import AppFormSupportingLinks from '../form/form-supporting-links/AppForm'
import AppFormCompanyBankAccount from '../form/form-company-bank-account/AppForm'
import AppFormExportSalary from '../form/form-employee/AppFormExportSalary'
import AppFormExportLetterNumber from '../form/form-letter-number/AppFormExportLetterNumber'
import AppFormClient from '../form/form-client/AppFormForOtherPage'
import AppFormProject from '../form/form-project/AppFormForOtherPage'
import AppFormPendingApproval from '../form/form-time-off-request/AppFormPendingApproval'
import AppFormPendingCancellation from '../form/form-time-off-request/AppFormPendingCancellation'
import AppModalDetailInvoice from '../modal/details/invoice-details/AppModalDetails'
import AppModalDetailExpense from '../modal/details/expense-details/AppModalDetails'
import AppModalDetailPayroll from '../modal/details/payroll-details/AppModalDetails'
import AppModalDetailSupportingLink from './details/supporting-link-details/AppModalDetails'
import AppModalDetailCompanyBankAccount from './details/company-bank-account-details/AppModalDetails'
import ActionButtonForm from 'src/components/form/general-input-form/ActionButtonForm'

// icons
import CIcon from '@coreui/icons-react'
import { cilWarning } from '@coreui/icons'

// styling
import { styleButtonVars3 } from '../custom-styles/buttonStyles'
import FormFileThumbnail from '../form/general-input-form/FormFileThumbnail'

const AppModalConfirmation = ({
  confirmationType,
  itemName,
  itemDetails,
  itemType,
  itemIndex,
  headerTitle,
  showModal,
  setShowModal,
  handleConfirmation,
  handleCardHeaderButton,
  values,
  errors,
  handleChange,
  handleFileInput,
  handleOnDateChange,
  handleSubmit,
  handleConfirmDelete,
  handleViewFile,
  descriptionText,
  disabled,
  isLoading,
  handleSelectInterval,
  handleSwitchRepeatForever,
  intervalValue,
  expenseIntervalOptions,
  handleAddInvoiceRecipients,
  handleChangeInvoiceRecipients,
  handleSelectCountryInvoiceRecipients,
  handleRemoveInvoiceRecipients,
  countryOptions,
  clientOptions,
  handleSelectClient,
  handleCheckbox,
  handleChangeShippingDetail,
  handleDateChangeShippingDetail,
  courierOptions,
  handleSearchInput,
  handleSelectCourier,
  handleSelectPic,
  picList,
  picValue,
  expenseCategoryOptions,
  expenseCategoryValue,
  expenseTagsOptions,
  handleSelectExpenseCategory,
  handleChangeFieldCategory,
  handleOnDateChangeCategory,
  expenseTransportationOptions,
  expenseFuelOptions,
  handleSelectOptionExpenseCategory,
  expenseTransportationValue,
  expenseFuelValue,
  tripTypeOptions,
  bookingThroughFlighOptions,
  bookingThroughTrainOptions,
  expenseFlightValue,
  expenseTrainValue,
  handleChangePassenger,
  handleAddPassenger,
  handleRemovePassenger,
  expenseAirplaneOptions,
  expenseAirplaneValue,
  bookingThroughAccomodationOptions,
  expenseAccomodationValue,
  provinceOptions,
  cityOptions,
  expenseAccomodationProvinceValue,
  expenseAccomodationCitiesValue,
  setSelectedMonth,
  setSelectedEmployeeType,
  selectedMonth,
  selectedEmployeeType,
  monthOptions,
  statusContractOptions,
  exportModeOptions,
  exportMode,
  handleSelectExportMode,
  letterTypeOptions,
  selectedLetterType,
  handleSelectLetterType,
  countryValue,
  countryPhone,
  handleSelectCountry,
  handleSelectCountryPhone,
  onDateChange,
  approvalRequestValue,
  handleSelectApprovalRequest,
  approvalCancellationRequestValue,
  handleSelectApprovalCancellationRequest,
  handleSelectUnpaidCategory
}) => {
  return (
    <>
      {
        (confirmationType === 'add-contract' ||
        confirmationType === 'add-other-files' ||
        confirmationType === 'add-attachments') && (
          <AppModal
            showModal={showModal}
            setShowModal={setShowModal}
            headerTitle={headerTitle}
            bodyDescription={
              <CRow className='justify-content-center'>
                <FormFileUpload
                  name={itemName}
                  colSize='6'
                  handleFileInput={handleFileInput}
                  handleFileOnDrop={handleFileInput}
                  multiple={true}
                  invalid={errors}
                  feedbackInvalid={errors}
                  isSpesificImage={false}
                />
              </CRow>
            }
          />
        )
      }
      {
        confirmationType === 'add-invoices' && (
          <AppModal
            showModal={showModal}
            setShowModal={setShowModal}
            headerTitle={headerTitle}
            bodyDescription={
              <AppCard
                className='mb-4'
                headerTitle={<h4>Invoice</h4>}
                bodyContent={
                  <AppForm
                    values={values}
                    errors={errors}
                    handleChange={handleChange}
                    onDateChange={handleOnDateChange}
                    handleFileInput={handleFileInput}
                    handleFileOnDrop={handleFileInput}
                    handleConfirmDelete={handleConfirmDelete}
                    handleAddInvoiceRecipients={handleAddInvoiceRecipients}
                    handleChangeInvoiceRecipients={handleChangeInvoiceRecipients}
                    handleSelectCountryInvoiceRecipients={handleSelectCountryInvoiceRecipients}
                    handleRemoveInvoiceRecipients={handleRemoveInvoiceRecipients}
                    countryOptions={countryOptions}
                    clientOptions={clientOptions}
                    handleSelectClient={handleSelectClient}
                    handleSearchInput={handleSearchInput}
                    handleCheckbox={handleCheckbox}
                    handleChangeShippingDetail={handleChangeShippingDetail}
                    handleDateChangeShippingDetail={handleDateChangeShippingDetail}
                    courierOptions={courierOptions}
                    handleSelectCourier={handleSelectCourier}
                    isFromModal={true}
                    handleSelectPic={handleSelectPic}
                    picList={picList}
                    picValue={picValue}
                  />
                }
                lowerBodyContent={
                  <>
                    <AppCard
                      className='mb-4'
                      headerTitle={
                        <AppCardHeader
                          headerTitle={<h4>Generated Invoice</h4>}
                        />
                      }
                      bodyContent={
                        <>
                          {
                            values?.file_generate_pdf?.length > 0 ? (
                              <FormFileThumbnail
                                name='file_generate_pdf'
                                colSize='6'
                                files={values?.file_generate_pdf}
                                className='justify-content-start align-items-center'
                                handleConfirmDelete={handleConfirmDelete}
                                handleViewFile={handleViewFile}
                              />
                            )
                            : (
                              <>Not Found</>
                            )
                          }
                        </>
                      }
                    />
                    <AppCard
                      className='mb-4'
                      headerTitle={
                        <AppCardHeader
                          headerTitle={<h4>Attachments</h4>}
                          headerButton="Upload new"
                          handleCardHeaderButton={handleCardHeaderButton}
                        />
                      }
                      bodyContent={
                        <>
                          {
                            values?.file?.length > 0 ? (
                              <FormFileThumbnail
                                name='invoice_attachments'
                                colSize='6'
                                files={values?.file}
                                className='justify-content-start align-items-center'
                                handleConfirmDelete={handleConfirmDelete}
                                handleViewFile={handleViewFile}
                              />
                            )
                            : (
                              <>Not Found</>
                            )
                          }
                        </>
                      }
                    />
                  </>
                }
              />
            }
            modalFooter={
              <>
                <CButton size='lg' color="secondary" onClick={() => setShowModal({ show: false, item: {} })}>
                  Cancel
                </CButton>
                {
                  isLoading ? (
                    <CButton color="primary" disabled>
                      <CSpinner as="span" className="me-2" size="sm" aria-hidden="true" />
                      <span role="status">Loading...</span>
                    </CButton>
                  ) : (
                    <CButton size='lg' style={styleButtonVars3} onClick={handleSubmit}>
                      Save
                    </CButton>
                  )
                }
              </>
            }
          />
        )
      }
      {
        confirmationType === 'add-expenses' && (
          <AppModal
            showModal={showModal}
            setShowModal={setShowModal}
            headerTitle={headerTitle}
            bodyDescription={
              <CRow className='justify-content-center'>
                <AppFormExpense
                  values={values}
                  errors={errors}
                  handleChange={handleChange}
                  onDateChange={handleOnDateChange}
                  handleFileInput={handleFileInput}
                  handleFileOnDrop={handleFileInput}
                  handleConfirmDelete={handleConfirmDelete}
                  handleSelectInterval={handleSelectInterval}
                  handleSwitchRepeatForever={handleSwitchRepeatForever}
                  intervalValue={intervalValue}
                  expenseIntervalOptions={expenseIntervalOptions}
                  expenseCategoryOptions={expenseCategoryOptions}
                  expenseCategoryValue={expenseCategoryValue}
                  expenseTagsOptions={expenseTagsOptions}
                  handleSelectExpenseCategory={handleSelectExpenseCategory}
                  handleChangeFieldCategory={handleChangeFieldCategory}
                  handleOnDateChangeCategory={handleOnDateChangeCategory}
                  expenseTransportationOptions={expenseTransportationOptions}
                  expenseFuelOptions={expenseFuelOptions}
                  handleSelectOptionExpenseCategory={handleSelectOptionExpenseCategory}
                  expenseTransportationValue={expenseTransportationValue}
                  expenseFuelValue={expenseFuelValue}
                  tripTypeOptions={tripTypeOptions}
                  bookingThroughFlighOptions={bookingThroughFlighOptions}
                  bookingThroughTrainOptions={bookingThroughTrainOptions}
                  expenseFlightValue={expenseFlightValue}
                  expenseTrainValue={expenseTrainValue}
                  handleChangePassenger={handleChangePassenger}
                  handleAddPassenger={handleAddPassenger}
                  handleRemovePassenger={handleRemovePassenger}
                  expenseAirplaneOptions={expenseAirplaneOptions}
                  expenseAirplaneValue={expenseAirplaneValue}
                  bookingThroughAccomodationOptions={bookingThroughAccomodationOptions}
                  expenseAccomodationValue={expenseAccomodationValue}
                  provinceOptions={provinceOptions}
                  cityOptions={cityOptions}
                  expenseAccomodationProvinceValue={expenseAccomodationProvinceValue}
                  expenseAccomodationCitiesValue={expenseAccomodationCitiesValue}
                />
              </CRow>
            }
            modalFooter={
              <>
                <CButton size='lg' color="secondary" onClick={() => setShowModal({ show: false, item: {} })}>
                  Cancel
                </CButton>
                <CButton size='lg' style={styleButtonVars3} onClick={handleSubmit}>
                  Save
                </CButton>
              </>
            }
          />
        )
      }
      {
        confirmationType === 'add-payroll' && (
          <AppModal
            showModal={showModal}
            setShowModal={setShowModal}
            headerTitle={headerTitle}
            backdrop={showModal?.backdrop ? showModal.backdrop : true}
            isLoading={isLoading}
            bodyDescription={
              <AppCard
                className='mb-4'
                headerTitle={<h4>Payroll</h4>}
                bodyContent={
                  <AppFormPayroll
                    values={values}
                    errors={errors}
                    handleChange={handleChange}
                    onDateChange={handleOnDateChange}
                    isEditPerPayroll={headerTitle?.toLocaleLowerCase().includes('edit') && !headerTitle?.toLocaleLowerCase().includes('bulk') ? true : false}
                    isEditBulkPayroll={headerTitle?.toLocaleLowerCase().includes('bulk') ? true : false}
                  />
                }
                lowerBodyContent={
                  <>
                  {
                    values?.salary_slip?.length > 0 && (
                      <AppCard
                        className='mb-4'
                        headerTitle={
                          <AppCardHeader
                            headerTitle={<h4>Salary Slip</h4>}
                          />
                        }
                        bodyContent={
                          <>
                            {
                              values?.salary_slip?.length > 0 ? (
                                <FormFileThumbnail
                                  name='payroll_salary_slip'
                                  colSize='6'
                                  files={values?.salary_slip}
                                  className='justify-content-start align-items-center'
                                  handleConfirmDelete={handleConfirmDelete}
                                  handleViewFile={handleViewFile}
                                />
                              )
                              : (
                                <>Not Found</>
                              )
                            }
                          </>
                        }
                      />
                    )
                  }
                    <AppCard
                      className='mb-4'
                      headerTitle={
                        <AppCardHeader
                          headerTitle={<h4>Attachments</h4>}
                          headerButton="Upload new"
                          handleCardHeaderButton={() => handleCardHeaderButton('payroll_attachments')}
                        />
                      }
                      bodyContent={
                        <>
                          {
                            values?.files?.length > 0 ? (
                              <FormFileThumbnail
                                name='payroll_attachments'
                                colSize='4'
                                files={values?.files}
                                className='justify-content-start align-items-center'
                                handleConfirmDelete={handleConfirmDelete}
                                handleViewFile={handleViewFile}
                              />
                            )
                            : (
                              <>Not Found</>
                            )
                          }
                        </>
                      }
                    />
                  </>
                }
              />
            }
            modalFooter={
              <>
                <CButton size='lg' color="secondary" onClick={() => setShowModal({ show: false, item: {} })} disabled={isLoading}>
                  Cancel
                </CButton>
                {
                  isLoading ? (
                    <CButton color="primary" disabled>
                      <CSpinner as="span" className="me-2" size="sm" aria-hidden="true" />
                      <span role="status">Loading...</span>
                    </CButton>
                  ) : (
                    <CButton size='lg' style={styleButtonVars3} onClick={handleSubmit}>
                      Save
                    </CButton>
                  )
                }
              </>
            }
          />
        )
      }
      {
        confirmationType === 'add-supporting-links' && (
          <AppModal
            showModal={showModal}
            setShowModal={setShowModal}
            headerTitle={headerTitle}
            bodyDescription={
              <CRow className='justify-content-center'>
                <AppFormSupportingLinks
                  values={values}
                  handleChange={handleChange}
                  errors={errors}
                />
              </CRow>
            }
            modalFooter={
              <>
                <CButton size='lg' color="secondary" onClick={() => setShowModal({ show: false, item: {} })}>
                  Cancel
                </CButton>
                <CButton size='lg' style={styleButtonVars3} onClick={handleSubmit}>
                  Save
                </CButton>
              </>
            }
          />
        )
      }
      {
        confirmationType === 'add-company-bank-account' && (
          <AppModal
            showModal={showModal}
            setShowModal={setShowModal}
            headerTitle={headerTitle}
            bodyDescription={
              <CRow className='justify-content-center'>
                <AppFormCompanyBankAccount
                  values={values}
                  handleChange={handleChange}
                  errors={errors}
                />
              </CRow>
            }
            modalFooter={
              <>
                <CButton size='lg' color="secondary" onClick={() => setShowModal({ show: false, item: {} })}>
                  Cancel
                </CButton>
                <CButton size='lg' style={styleButtonVars3} onClick={handleSubmit}>
                  Save
                </CButton>
              </>
            }
          />
        )
      }
      {
        confirmationType === 'detail-invoice' && (
          <AppModal
            showModal={showModal}
            setShowModal={setShowModal}
            headerTitle='Project Invoice Details'
            bodyDescription={
              <AppCard
                className='mb-4'
                headerTitle={<h4>Invoice</h4>}
                bodyContent={
                  <AppModalDetailInvoice
                    invoiceDetails={itemDetails}
                    handleViewFile={handleViewFile}
                  />
                }
                lowerBodyContent={
                  <>
                    <AppCard
                      className='mb-4'
                      headerTitle={
                        <AppCardHeader
                          headerTitle={<h4>Generated Invoice</h4>}
                        />
                      }
                      bodyContent={
                        <>
                          {
                            itemDetails?.generate_pdf_attachments?.length > 0 ? (
                              <FormFileThumbnail
                                name='file_generate_pdf'
                                colSize='6'
                                files={itemDetails?.generate_pdf_attachments}
                                className='justify-content-start align-items-center'
                                handleViewFile={handleViewFile}
                                isDetailPage={true}
                              />
                            )
                            : (
                              <>Not Found</>
                            )
                          }
                        </>
                      }
                    />
                    <AppCard
                      className='mb-4'
                      headerTitle={
                        <AppCardHeader
                          headerTitle={<h4>Attachments</h4>}
                        />
                      }
                      bodyContent={
                        <>
                          {
                            itemDetails?.attachments?.length > 0 ? (
                              <FormFileThumbnail
                                name='invoice_attachments'
                                colSize='6'
                                files={itemDetails?.attachments}
                                className='justify-content-start align-items-center'
                                handleViewFile={handleViewFile}
                                isDetailPage={true}
                              />
                            )
                            : (
                              <>Not Found</>
                            )
                          }
                        </>
                      }
                    />
                  </>
                }
              />
            }
          />
        )
      }
      {
        confirmationType === 'detail-expense' && (
          <AppModal
            showModal={showModal}
            setShowModal={setShowModal}
            headerTitle='Project Expense Details'
            bodyDescription={
              <AppModalDetailExpense
                expenseDetails={itemDetails}
                handleViewFile={handleViewFile}
              />
            }
          />
        )
      }
      {
        confirmationType === 'detail-payroll' && (
          <AppModal
            showModal={showModal}
            setShowModal={setShowModal}
            headerTitle='Payroll Details'
            bodyDescription={
              <AppModalDetailPayroll
                payrollDetails={itemDetails}
                handleViewFile={handleViewFile}
              />
            }
          />
        )
      }
      {
        confirmationType === 'detail-supporting-link' && (
          <AppModal
            showModal={showModal}
            setShowModal={setShowModal}
            headerTitle='Supporting Link Details'
            bodyDescription={
              <AppModalDetailSupportingLink
                supportingLinkDetails={itemDetails}
              />
            }
          />
        )
      }
      {
        confirmationType === 'detail-company-bank-account' && (
          <AppModal
            showModal={showModal}
            setShowModal={setShowModal}
            headerTitle="Company Bank Account Details"
            bodyDescription={
              <AppModalDetailCompanyBankAccount
                companyBankAccountDetails={itemDetails}
              />
            }
          />
        )
      }
      {
        confirmationType === 'change-status-contract' && (
          <AppModal
            showModal={showModal}
            setShowModal={setShowModal}
            bodyTitleIcon={<CIcon icon={cilWarning} size='8xl' />}
            bodyTitle={`Are you sure you are going to ${itemType == true ? 'sign' : 'un-signed'} this contract?`}
            className={'text-center'}
            modalFooter={
              <>
                <CButton size='lg' color="secondary" onClick={() => setShowModal({ show: false, item: {} })}>
                  Cancel
                </CButton>
                <CButton size='lg' style={styleButtonVars3} onClick={handleSubmit}>
                  Save
                </CButton>
              </>
            }
          />
        )
      }
      {
        confirmationType === 'export-salary' && (
          <AppModal
            showModal={showModal}
            setShowModal={setShowModal}
            headerTitle="Export Salary"
            bodyDescription={
              <CRow className='justify-content-center'>
                <AppFormExportSalary
                  errors={errors}
                  monthOptions={monthOptions}
                  month={selectedMonth}
                  handleSelectMonth={setSelectedMonth}
                  statusContractOptions={statusContractOptions}
                  statusContract={selectedEmployeeType}
                  handleSelectStatusContract={setSelectedEmployeeType}
                />
              </CRow>
            }
            modalFooter={
              <>
                <CButton size='lg' color="secondary" onClick={() => setShowModal({ show: false })}>
                  Cancel
                </CButton>
                {
                  isLoading ? (
                    <CButton color="primary" disabled>
                      <CSpinner as="span" className="me-2" size="sm" aria-hidden="true" />
                      <span role="status">Loading...</span>
                    </CButton>
                  ) : (
                    <CButton size='lg' style={styleButtonVars3} onClick={handleSubmit}>
                      Export
                    </CButton>
                  )
                }
              </>
            }
          />
        )
      }
      {
        confirmationType === 'export-letter-number' && (
          <AppModal
            showModal={showModal}
            setShowModal={setShowModal}
            headerTitle="Export Letter Number"
            bodyDescription={
              <CRow className='justify-content-center'>
                <AppFormExportLetterNumber
                  errors={errors}
                  exportModeOptions={exportModeOptions}
                  exportMode={exportMode}
                  handleSelectExportMode={handleSelectExportMode}
                  letterTypeOptions={letterTypeOptions}
                  letterType={selectedLetterType}
                  handleSelectLetterType={handleSelectLetterType}
                  monthOptions={monthOptions}
                  month={selectedMonth}
                  handleSelectMonth={setSelectedMonth}
                  values={values}
                  onDateChange={onDateChange}
                />
              </CRow>
            }
            modalFooter={
              <>
                <CButton size='lg' color="secondary" onClick={() => setShowModal({ show: false })}>
                  Cancel
                </CButton>
                {
                  isLoading ? (
                    <CButton color="primary" disabled>
                      <CSpinner as="span" className="me-2" size="sm" aria-hidden="true" />
                      <span role="status">Loading...</span>
                    </CButton>
                  ) : (
                    <CButton size='lg' style={styleButtonVars3} onClick={handleSubmit}>
                      Export
                    </CButton>
                  )
                }
              </>
            }
          />
        )
      }
      {
        confirmationType === 'create-new-client' && (
          <AppModal
            showModal={showModal}
            setShowModal={setShowModal}
            headerTitle={
              <div className="d-flex justify-content-between align-items-center w-100 px-2">
                <span>{headerTitle}</span>
                {values?.client_name && (
                  <span style={{ color: '#C0392B', fontWeight: 'bold' }}>
                    {values?.client_name}
                  </span>
                )}
              </div>
            }
            bodyDescription={
              <CRow className='justify-content-center'>
                <AppFormClient
                  values={values}
                  errors={errors}
                  handleChange={handleChange}
                  countryOptions={countryOptions}
                  countryValue={countryValue}
                  countryPhone={countryPhone}
                  handleSelectCountry={handleSelectCountry}
                  handleSelectCountryPhone={handleSelectCountryPhone}
                />
              </CRow>
            }
            modalFooter={
              <>
                <CButton size='lg' color="secondary" onClick={() => setShowModal({ show: false })}>
                  Cancel
                </CButton>
                <CButton size='lg' style={styleButtonVars3} onClick={handleSubmit}>
                  Save
                </CButton>
              </>
            }
          />
        )
      }
      {
        confirmationType === 'create-new-project' && (
          <AppModal
            showModal={showModal}
            setShowModal={setShowModal}
            headerTitle={headerTitle}
            bodyDescription={
              <CRow className='justify-content-center'>
                <AppFormProject
                  values={values}
                  errors={errors}
                  handleChange={handleChange}
                  onDateChange={onDateChange}
                  clientOptions={clientOptions}
                  handleSelectClient={handleSelectClient}
                  handleSearchInput={handleSearchInput}
                />
              </CRow>
            }
            modalFooter={
              <>
                <CButton size='lg' color="secondary" onClick={() => setShowModal({ show: false })}>
                  Cancel
                </CButton>
                <CButton size='lg' style={styleButtonVars3} onClick={handleSubmit}>
                  Save
                </CButton>
              </>
            }
          />
        )
      }
      {
        confirmationType === 'delete-item' && (
          <AppModal
            showModal={showModal}
            setShowModal={setShowModal}
            bodyTitleIcon={<CIcon icon={cilWarning} size='8xl' />}
            bodyTitle={`Are you sure you want to delete this ${itemName}?`}
            bodyDescription={`Once confirmed, it can not be undo and all ${itemName} details will be deleted permanently.`}
            className={'text-center'}
            backdrop={'static'}
            isLoading={isLoading ? true : false}
            modalFooter={
              <>
                <CButton size='lg' color="secondary" disabled={isLoading} onClick={() => setShowModal({ show: false, item: {} })}>
                  No
                </CButton>
                {
                  isLoading ? (
                    <CButton color="primary" disabled>
                      <CSpinner as="span" className="me-2" size="sm" aria-hidden="true" />
                      <span role="status">Loading...</span>
                    </CButton>
                  ) : (
                    <CButton size='lg' style={styleButtonVars3} onClick={() => handleConfirmation(itemIndex, itemType)}>
                      Save
                    </CButton>
                  )
                }
              </>
            }
          />
        )
      }
      {
        confirmationType === 'delete-all-payroll' && (
          <AppModal
            showModal={showModal}
            setShowModal={setShowModal}
            bodyTitleIcon={<CIcon icon={cilWarning} size='8xl' />}
            bodyTitle={`Are you sure you are going to delete all payrolls for this employee?`}
            bodyDescription={`Once done it cannot be reverted`}
            className={'text-center'}
            backdrop={'static'}
            isLoading={isLoading}
            modalFooter={
              <>
                <CButton size='lg' color="secondary" onClick={() => setShowModal({ show: false, item: {} })}>
                  No
                </CButton>
                {
                  isLoading ? (
                    <CButton color="primary" disabled>
                      <CSpinner as="span" className="me-2" size="sm" aria-hidden="true" />
                      <span role="status">Loading...</span>
                    </CButton>
                  ) : (
                    <CButton size='lg' style={styleButtonVars3} onClick={() => handleConfirmation(itemIndex, itemType)}>
                      Save
                    </CButton>
                  )
                }
              </>
            }
          />
        )
      }
      {
        confirmationType === 'pending-approval-time-off' && (
          <AppModal
            showModal={showModal}
            setShowModal={setShowModal}
            bodyTitleIcon={<CIcon icon={cilWarning} size='8xl' />}
            bodyTitle={`Are you sure you want to approve this time-off request?`}
            bodyDescription={
              <div className="d-flex">
              <CRow className='justify-content-center'>
                <div className='mb-3'>
                Once confirmed, it can not be undo and all the approval decision will be informed directly to the employee.
                </div>
                <AppFormPendingApproval
                  values={values}
                  errors={errors}
                  handleChange={handleChange}
                  approvalRequestValue={approvalRequestValue}
                  handleSelectApprovalRequest={handleSelectApprovalRequest}
                  handleSelectUnpaidCategory={handleSelectUnpaidCategory}
                />
              </CRow>
              </div>

            }
            className={'text-center'}
            backdrop={'static'}
            isLoading={isLoading ? true : false}
            modalFooter={
              <>
                <CButton size='lg' color="secondary" disabled={isLoading} onClick={() => setShowModal({ show: false, item: {} })}>
                  No
                </CButton>
                {
                  isLoading ? (
                    <CButton color="primary" disabled>
                      <CSpinner as="span" className="me-2" size="sm" aria-hidden="true" />
                      <span role="status">Loading...</span>
                    </CButton>
                  ) : (
                    <CButton size='lg' style={styleButtonVars3} onClick={handleSubmit}>
                      Save
                    </CButton>
                  )
                }
              </>
            }
          />
        )
      }
      {
        confirmationType === 'pending-cancellation-time-off' && (
          <AppModal
            showModal={showModal}
            setShowModal={setShowModal}
            bodyTitleIcon={<CIcon icon={cilWarning} size='8xl' />}
            bodyTitle={`Are you sure you want to approve this cancellation time-off request?`}
            bodyDescription={
              <div className="d-flex">
                <CRow className='justify-content-center'>
                  <div className='mb-3'>
                  Once confirmed, it can not be undo and all the cancellation decision will be informed directly to the employee.
                  </div>
                  <AppFormPendingCancellation
                    values={values}
                    errors={errors}
                    handleChange={handleChange}
                    approvalRequestValue={approvalCancellationRequestValue}
                    handleSelectApprovalRequest={handleSelectApprovalCancellationRequest}
                  />
                </CRow>
              </div>
            }
            className={'text-center'}
            backdrop={'static'}
            isLoading={isLoading ? true : false}
            modalFooter={
              <>
                <CButton size='lg' color="secondary" disabled={isLoading} onClick={() => setShowModal({ show: false, item: {} })}>
                  No
                </CButton>
                {
                  isLoading ? (
                    <CButton color="primary" disabled>
                      <CSpinner as="span" className="me-2" size="sm" aria-hidden="true" />
                      <span role="status">Loading...</span>
                    </CButton>
                  ) : (
                    <CButton size='lg' style={styleButtonVars3} onClick={handleSubmit}>
                      Save
                    </CButton>
                  )
                }
              </>
            }
          />
        )
      }
      {
        confirmationType === 'confirmation' && (
          <AppModal
            showModal={showModal}
            setShowModal={setShowModal}
            headerTitle={headerTitle}
            bodyTitle={descriptionText}
            className={'text-center'}
            modalFooter={
              <>
                <ActionButtonForm
                  isLoading={isLoading}
                  disabled={disabled}
                  onCancel={() => setShowModal({ show: false, item: {} })}
                  onSave={handleSubmit}
                />
              </>
            }
          />
        )
      }
    </>
  )
}

export default AppModalConfirmation
